module.exports = __webpack_public_path__ + "static/media/ProfessionalUX.f1b132b7.svg";